import { useSnackbar } from 'notistack';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogProps,
  DialogTitle,
} from '@mui/material';

import { Area } from '@/types';
import { useDeleteAreaMutation } from '@/services';

export interface DeleteAreaProps extends DialogProps {
  area: Area;
  onClose(): void;
}

const DeleteArea: React.FC<DeleteAreaProps> = ({ area, onClose, ...props }) => {
  const { enqueueSnackbar } = useSnackbar();

  const [deleteArea, deleteAreaResponse] = useDeleteAreaMutation();

  async function handleDeleteArea() {
    try {
      await deleteArea(area).unwrap();

      onClose();
    } catch (error) {
      enqueueSnackbar(error.data, { variant: 'error' });
    }
  }

  return (
    <Dialog fullWidth {...props}>
      <DialogTitle fontWeight="bold">{area?.name}</DialogTitle>

      <DialogContent dividers>
        <DialogContentText>Вы действительно хотите удалить "{area?.name}"?</DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button
          color="secondary"
          variant="outlined"
          size="small"
          disabled={deleteAreaResponse.isLoading}
          onClick={onClose}
        >
          Закрыть
        </Button>

        <Button variant="contained" disabled={deleteAreaResponse.isLoading} size="small" onClick={handleDeleteArea}>
          Да
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteArea;
